import { GenericFieldFactory } from "../../Common/_generics/GenericFieldFactory";

export const LicensesSecondaryViewStore = GenericFieldFactory("LICENSES_SECONDARY_VIEW", null);